module.exports = __webpack_public_path__ + "media/src/assets/images/campaign-play-button-c602a5db351571bda102b93bbdd7f0e3.svg";